<template>
    <div id="yt-video">
        <template v-if="ytvideo">
            <div id="yt-modal">
                <div class="modal fade yt-modal" id="yt-single" tabindex="-1" role="dialog">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <div class="modal-title h3">Youtube</div>
                                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                            </div>
                            <div class="modal-body">
                                <iframe width="100%" height="315" :src="'https://www.youtube-nocookie.com/embed/'+ytvideo"
                                        title="YouTube video player"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen>
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default
    {
        props:
        {
            template:
                {
                    type: String,
                    default: "#vue-yt-video"
                }
        },
        data: function()
        {
            return {
               youtubeid:''
            }
        },
        created:function()
        {
            vueEventHub.$on("youtube-id", yt =>
            {
                this.youtubeid = yt
            });
        },
        computed:
            {
                ytvideo:function()
                {
                    return this.youtubeid;
                }
            }
    }
</script>
